<script>
  import Button from '../../Common/Button.svelte';

  export let config;
  export let edgeServerCount;
  export let onSave;
  export let onCancel;

  let showAdvanced = false;

  const toggleAdvanced = () => {
    showAdvanced = !showAdvanced;
  };

  const onEdgeServerCountChange = () => {
    const size = parseInt(edgeServerCount);
    if (size > 0) {
      config.origin = { minSize: 1, maxSize: 2, desiredCapacity: 1 };
      config.edge = { minSize: size, maxSize: 20, desiredCapacity: size };
    } else {
      config.origin = { minSize: 0, maxSize: 2, desiredCapacity: 0 };
      config.edge = { minSize: 0, maxSize: 20, desiredCapacity: 0 };
    }
  };
</script>

<main>
  <label for="edgeServers">Minimum antall servere</label>
  <select id="edgeServers" bind:value={edgeServerCount} on:change={onEdgeServerCountChange}>
    <option value="0">0 (steng ned)</option>
    <option value="1">1 (3000 seere)</option>
    <option value="2">2 (6000 seere)</option>
    <option value="3">3 (9000 seere)</option>
    <option value="4">4 (12000 seere)</option>
  </select>

  {#if !showAdvanced}
    <p class="toggle-advanced" on:click={toggleAdvanced}>Vis avansert konfigurasjon</p>
  {:else}
    <p class="toggle-advanced" on:click={toggleAdvanced}>Skjul avansert konfigurasjon</p>

    <h3>Edge Server (server seere)</h3>
    Min:<input type="number" min="0" bind:value={config.edge.minSize} />
    Desired:
    <input type="number" min={config.edge.minSize} bind:value={config.edge.desiredCapacity} />
    Max:
    <input type="number" min={config.edge.minSize} bind:value={config.edge.maxSize} />

    <h3>Origin Server (server strømmere)</h3>
    Min:<input type="number" min="0" bind:value={config.origin.minSize} />
    Desired:
    <input type="number" min={config.origin.minSize} bind:value={config.origin.desiredCapacity} />
    Max:
    <input type="number" min={config.origin.minSize} bind:value={config.origin.maxSize} />
  {/if}

  <div class="btn-container">
    <Button on:click={onCancel} class="cancel-button" secondary>Avbryt</Button>
    <Button class="confirm-button" on:click={onSave}>Ok</Button>
  </div>
</main>

<style>
  h3 {
    font-size: 14px;
    font-weight: 400;
  }

  select,
  input {
    outline: none;
    padding: 10px;
    font-size: 16px;
    width: 54px;
    border: none;
    border-radius: 4px;
    box-sizing: border-box;
  }

  .btn-container {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
  }

  .toggle-advanced {
    text-decoration: underline;
    cursor: pointer;
    margin: 40px 0;
  }
</style>
